import classNames from 'classnames';
import React, { type CSSProperties, memo } from 'react';
import styled from 'styled-components';
import { LoadingCylon } from '../SVG';
import { type MaskProps } from './Mask.types';

export const Mask: React.FC<MaskProps> = memo(
  ({
    background,
    className = '',
    colorMode,
    style,
    left,
    loading = true,
    onClickAction,
    position,
    top,
    height,
  }) => {
    const combinedClassNames = classNames('loading-mask', className, colorMode);
    return (
      <Wrapper
        className={combinedClassNames}
        onClick={onClickAction}
        height={height}
        position={position}
        justifyContent="center"
        alignContent="center"
        background={background}
        style={{ ...style, left, top }}
      >
        {loading && <LoadingCylon />}
      </Wrapper>
    );
  },
);

interface WrapperProps {
  height: CSSProperties['height'];
  position: CSSProperties['position'];
  justifyContent: CSSProperties['justifyContent'];
  alignContent: CSSProperties['alignContent'];
  background: CSSProperties['background'];
}
// Styled Components
const Wrapper = styled('div').withConfig({
  shouldForwardProp: (prop) => !['justifyContent', 'alignContent'].includes(prop),
})<WrapperProps>`
  display: grid;
  justify-content: center;
  align-content: center;
  height: ${(p) => p.height || '100%'};
  position: ${(p) => p.position || 'fixed'};
  background: ${(p) => p.background || 'transparent'};
  z-index: 10000;
  width: 100%;

  &.light {
    background: rgba(255, 255, 255, 0.6);
  }

  &.dark {
    background: rgba(32, 32, 32, 0.6);
  }
`;

// Display Name
Mask.displayName = 'Mask';

export default Mask;
